import HomePage from '@/pages/HomePage/HomePage'
import { PAGE_LINKS, PAGE_ROOT } from '../pageConst'
import PricingPage from '@/pages/PricingPage/PricingPage'
import LoginPage from '@/pages/LoginPage/LoginPage'
import ResetPwdPage from '@/pages/ResetPwdPage/ResetPwdPage'
import InfoBindPage from '@/pages/InfoBindPage/InfoBindPage'
import ContactPage from '@/pages/ContactPage/ContactPage'
import { Navigate } from 'react-router-dom'
import PageLayout from '@/components/PageLayout/PageLayout'
import PrivacyPage from '@/pages/PrivacyPage/PrivacyPage'
import TermsOfServicePage from '@/pages/TermsOfServicePage/TermsOfServicePage'
import FreeTrialPage from '@/pages/FreeTrialPage/FreeTrialPage'
import KnowledgeFormPage from '@/pages/KnowledgeFormPage/KnowledgeFormPage'
// import TestPage from '@/pages/TestPage/TestPage'

const routes = [
  {
    element: <HomePage />,
    index: true,
  },
  {
    path: PAGE_LINKS.pricing,
    element: <PricingPage />,
  },
  {
    path: PAGE_LINKS.login,
    element: <LoginPage />,
  },
  {
    path: PAGE_LINKS.resetPwd,
    element: <ResetPwdPage />,
  },
  {
    path: PAGE_LINKS.infoBind,
    element: <InfoBindPage />,
  },
  {
    path: PAGE_LINKS.contact,
    element: <ContactPage />,
  },
  {
    path: PAGE_LINKS.freeTrial,
    element: <FreeTrialPage />,
  },

  //NOTE: 目前没有这个的设计图
  // {
  //   path: PAGE_LINKS.help,
  //   element: <HelpPage />
  // },
  {
    path: PAGE_LINKS.privacy,
    element: <PrivacyPage />,
  },
  {
    path: PAGE_LINKS.termsOfService,
    element: <TermsOfServicePage />,
  },
  {
    path: PAGE_LINKS.knowledgeForm,
    element: <KnowledgeFormPage />,
  },

  /*   {
    path: PAGE_LINKS.test,
    element: <TestPage />,
  }, */
  {
    /** NOT FOUND */
    path: '*',
    element: <Navigate to={PAGE_ROOT} replace />,
  },
]

export const landingRoutes = [
  {
    path: PAGE_ROOT,
    element: <PageLayout />,
    children: routes,
  },
]
